import React from 'react';
import { REPLAY_SHORTCUTS } from './useReplayShortcuts';

interface ReplayShortcutsHelpProps {
    onClose: () => void;
    canCopyLink: boolean;
}

const kbdStyle: React.CSSProperties = {
    display: 'inline-block',
    minWidth: 22,
    padding: '1px 6px',
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid #444',
    borderBottomWidth: 2,
    borderRadius: 3,
    color: '#e6e6e6',
    fontFamily: '"Consolas", "Menlo", monospace',
    fontSize: 11,
    lineHeight: '16px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
};

const ReplayShortcutsHelp: React.FC<ReplayShortcutsHelpProps> = ({ onClose, canCopyLink }) => (
    <div
        onClick={onClose}
        style={{
            position: 'absolute', inset: 0, zIndex: 30,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'rgba(0,0,0,0.45)',
        }}
    >
        <div
            onClick={e => e.stopPropagation()}
            role="dialog"
            aria-label="Keyboard shortcuts"
            style={{
                background: 'rgba(16,16,20,0.95)', border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 6, padding: '12px 16px 10px', minWidth: 300, maxWidth: '90%',
                maxHeight: '90%', overflowY: 'auto',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ color: '#fff', fontSize: '0.85rem', fontWeight: 700 }}>Keyboard shortcuts</span>
                <button
                    onClick={onClose}
                    title="Close (Esc)"
                    style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: '0 2px' }}
                >
                    ×
                </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 16, rowGap: 5, alignItems: 'center' }}>
                {REPLAY_SHORTCUTS.filter(s => canCopyLink || !s.copyLink).map(s => (
                    <React.Fragment key={s.label}>
                        <span style={{ display: 'flex', gap: 4, alignItems: 'center', color: '#666', fontSize: 11 }}>
                            {s.keys.map((k, i) => (
                                <React.Fragment key={k}>
                                    {i > 0 && '/'}
                                    <kbd style={kbdStyle}>{k}</kbd>
                                </React.Fragment>
                            ))}
                        </span>
                        <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.78rem' }}>{s.label}</span>
                    </React.Fragment>
                ))}
            </div>
            <div style={{ marginTop: 10, color: '#777', fontSize: '0.7rem' }}>
                Shortcuts work while the mouse is over the replay, or in fullscreen.
            </div>
        </div>
    </div>
);

export default ReplayShortcutsHelp;
